class slideSlider extends HTMLElement {
  constructor() {
    super();
    this.sortImages();
    this.direction = 'horizontal';
    this.sliderValidator = new SliderToInitialize(this.tagName.toLowerCase());
    this.isIpadPro = window.matchMedia('(min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none)').matches;
    if (this.sliderValidator.toInitialize) {
      this.init();
    }
  }

  init() {
    if (!Antonioli.settings.isDesktop == true) {
      this.setupPinchZoom();
    }

    if (this.getAttribute('direction') === 'vertical') {
      this.direction = 'vertical';
    }
    this.swiper = new Swiper(this, {
      slidesPerView: this.getAttribute('number-to-show'),
      loop: this.getAttribute('loop') === 'true',
      thumbsswiper: this.getAttribute('tumbnails'),
      zoom: {
        enabled: false,
        maxRatio: 5,
      },
      autoplay: {
        delay: parseInt(this.getAttribute('time-rotation')) || 0,
        enabled: (/true/).test(this.getAttribute('autoplay'))
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: this.isIpadPro && this.dataset.id == "carousel-product" ? this.getAttribute('number-to-show-ipad') : this.getAttribute('number-to-show-desktop'),
          destroy: {
            deleteInstance: this.getAttribute('no-desktop')
          },
          direction: this.direction
        }
      },
      on: {
        progress: () => {
          if (this.classList.contains("zoom-slider")) {
            //console.log(this.querySelector('.swiper-slide-active').getAttribute('real-index'))
          }
        },
        init: () => {
          this.calcHeightArrow();
        },
        resize: () => {
          this.calcHeightArrow();
        }
      },
    });
  }

  calcHeightArrow() {
    if(this.hasAttribute('with-arrow') == true && Antonioli.settings.isDesktop == true) {
      const directionArrows = this.querySelectorAll('.swiper-button-next, .swiper-button-prev');
      const imageHeight = this.querySelector('img').height;

      directionArrows.forEach(arrow => {
        arrow.style.height = `${imageHeight}px`;
      });
    }
  }

  setupPinchZoom() {

    let pinchZoomInstances = [];

    if (!this.querySelector('pinchable-image')) return

    this.allImagesInZoomModal = this.querySelectorAll('li');

    const reorderer = new ElementReorderer(this.allImagesInZoomModal, 'second', 1);
    reorderer.reorderElements();

    Array.from(this.querySelector('pinchable-image').querySelectorAll('li img'))
        .forEach( (el) => {
          let pinchZoomInstance = new PinchZoom(el, {
            maxZoom: 4,
            minZoom: 1,
            draggableUnzoomed: false,
            animationDuration: 200,
            onZoomStart: () => {
              this.swiper.allowTouchMove = false; // Disabilita il movimento di Swiper durante il pinch
            },
            onZoomEnd: () => {
              if (pinchZoomInstance.zoomFactor === 1) {
                // Se il fattore di zoom è tornato a 1, significa che l'utente ha eseguito un pinch-out
                pinchZoomInstance.zoomFactor = 1;
                pinchZoomInstance.offset.x = 0;
                pinchZoomInstance.offset.y = 0;
                pinchZoomInstance.update();

                // Rimuovi la transizione dopo l'animazione
                el.addEventListener('transitionend', function transitionEndHandler() {
                  el.style.transition = '';
                  el.removeEventListener('transitionend', transitionEndHandler);
                });
              }

              // Ripristina il movimento di Swiper solo se lo slider è stato spostato manualmente
              if (this.swiper.activeIndex !== this.swiper.previousIndex) {
                this.swiper.allowTouchMove = true;
                this.swiper.slideTo(this.swiper.activeIndex, 0, false);
              }
            }
          });
          pinchZoomInstances.push(pinchZoomInstance);
    });
  }

  sortImages() {
    const allImages = this.querySelectorAll('img');
    if (allImages?.length < 2) return
    allImages.forEach((img, index) => {
      if (!img.src.includes('_66-L')) return
      const currentSlide = img.closest('.swiper-slide')

      if (index === 0) {
        const secondSlide = allImages[1].closest('.swiper-slide');
        const tmpSlide = currentSlide.innerHTML
        currentSlide.innerHTML = secondSlide.innerHTML
        secondSlide.innerHTML = tmpSlide
      } else {
        const firstSlide = allImages[0].closest('.swiper-slide')
        firstSlide.parentNode.insertBefore(currentSlide, firstSlide.nextSibling);
      }

    })
  }
}


customElements.define('swiper-slider', slideSlider);





class ImageSlider extends HTMLElement {
  constructor() {
    super();
    this.setup();
  }

  setup() {
    this.nextArrowClass = '.swiper-arrow-next'
    this.prevArrowClass = '.swiper-arrow-prev'
    this.arrowNext = this.querySelector(this.nextArrowClass);
    this.arrowBack = this.querySelector(this.prevArrowClass);
    this.slides = Array.from(this.querySelectorAll('.product-slide'));
    this.firstSlide = this.slides[0];
    this.currentSlide = this.firstSlide;
    this.currentSlide.style.transform = 'translateX(0)';
    this.nextSlide = this.findNextSlide(this.currentSlide);
  }
  connectedCallback() {
    this.initializeSlider();
    this.updateSlideNavigation();
    this.addEventListener('click', this.handleArrowClick.bind(this));
    this.setupTouchHandlers();
  }

  findNextSlide(currentSlide) {
   return  currentSlide.nextElementSibling;
  }

  findPrevSlide(currentSlide) {
    return currentSlide.previousElementSibling;
  }

  updateSlideNavigation() {
    this.arrowNext.classList.toggle('tw-opacity-0', !this.nextSlide);
    this.arrowBack.classList.toggle('tw-opacity-0', this.currentSlide === this.firstSlide);


    const sliderMobile = this.querySelector('[data-navigation]');
    const lastSlide = this.slides[this.slides.length - 1]
    const lastIndex = lastSlide.dataset.index

    const  percentage = (this.currentSlide.dataset.index / lastIndex) * 100;
    sliderMobile.style.backgroundImage = `linear-gradient(to right, #000000 ${percentage.toFixed()}%, #eaeaea ${percentage.toFixed()}% )`;

  }

  setNextSlide() {
    this.currentSlide = this.nextSlide;
    this.nextSlide = this.findNextSlide(this.currentSlide);
    this.updateSlideNavigation();
  }

  setPrevSlide() {
    const prevSlide = this.findPrevSlide(this.currentSlide);
    if (prevSlide) {
      this.nextSlide = this.currentSlide;
      this.currentSlide = prevSlide;
    }
    this.updateSlideNavigation();
  }

  handleArrowClick(event) {
    if (event.target.closest(`${this.nextArrowClass}:not(.disable)`)) {
      event.preventDefault();
      this.slideNext();
    } else if (event.target.closest(`${this.prevArrowClass}:not(.disable)`)) {
      event.preventDefault();
      this.slidePrev();
    }
  }


  initializeSlider() {
    if (this.slides.length > 1) {
      this.arrowBack.classList.add('visible');
      this.arrowNext.classList.add('visible');
    }
  }

  slideNext() {
    if (!this.nextSlide) return
    this.currentSlide.style.transform = 'translateX(-100%)';
    this.nextSlide.style.transform = 'translateX(0)';
    this.setNextSlide();
  }

  slidePrev() {
    if (this.currentSlide !== this.firstSlide) {
      this.findPrevSlide(this.currentSlide).style.transform = 'translateX(0)';

      this.currentSlide.style.transform = 'translateX(100%)';
      this.setPrevSlide();
    }
  }
  setupTouchHandlers() {
    const touchsurface = this;

    let startX, startY, dist, startTime, windowStart, isMouseDown = false;

    const preventTouch = (e) => {
      const minValue = 5;
      const clientX = (e.touches ? e.touches[0].clientX : e.clientX) - startX;
      if (Math.abs(clientX) > minValue) {
        e.preventDefault();
      }
    };

    const handleSwipe = (e, isRightSwipe, isLeftSwipe) => {
      if (isRightSwipe) {
        e.preventDefault();
        this.slideNext();
      } else if (isLeftSwipe) {
        e.preventDefault();
        this.slidePrev();
      }
    };

    const handleTouchEnd = (e) => {
      const touchobj = e.changedTouches ? e.changedTouches[0] : e;
      const dist = (touchobj.pageX || touchobj.clientX) - startX;
      const isRightSwipe = dist <= -3;
      const isLeftSwipe = dist >= 3;
      if (window.scrollY === windowStart && Math.abs((touchobj.pageY || touchobj.clientY) - startY) <= 60) {
        handleSwipe(e, isRightSwipe, isLeftSwipe);
      }
    };

    touchsurface?.addEventListener('touchstart', (e) => {
      const touchobj = e.changedTouches[0];
      dist = 0;
      startX = touchobj.pageX;
      startY = touchobj.pageY;
      windowStart = window.scrollY;
      startTime = new Date().getTime();
    }, true);

    touchsurface?.addEventListener('touchmove', preventTouch, { passive: false });
    touchsurface?.addEventListener('touchend', handleTouchEnd, false);

  }
}

customElements.define("plp-slider", ImageSlider);
